import { createRouter, createWebHashHistory } from 'vue-router'

import MissionControl from '@/components/MissionControl.vue'
import Chat from '@/components/Chat.vue'

const routes = [
  {
    path: '/',
    name: 'MissionControl',
    component: MissionControl
  },
  {
    path: '/chat',
    name: 'Chat',
    component: Chat
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

export default router
